var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 12.001C21.0001 7.03223 16.9688 3.00098 12.0001 3.00098C7.03131 3.00098 3.00006 7.03223 3.00006 12.001C3.00006 16.9697 7.03131 21.001 12.0001 21.001C16.9688 21.001 21.0001 16.9697 21.0001 12.001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1399 15.6775L15.5048 12.4366C15.5796 12.391 15.6414 12.327 15.6843 12.2507C15.7271 12.1743 15.7497 12.0882 15.7497 12.0007C15.7497 11.9131 15.7271 11.827 15.6843 11.7507C15.6414 11.6743 15.5796 11.6103 15.5048 11.5647L10.1399 8.32379C10.0631 8.27772 9.97528 8.25294 9.88564 8.25198C9.79601 8.25103 9.70773 8.27393 9.62986 8.31835C9.552 8.36277 9.48736 8.4271 9.44256 8.50475C9.39776 8.58239 9.37443 8.67056 9.37495 8.7602V15.2411C9.37443 15.3308 9.39776 15.4189 9.44256 15.4966C9.48736 15.5742 9.552 15.6386 9.62986 15.683C9.70773 15.7274 9.79601 15.7503 9.88564 15.7494C9.97528 15.7484 10.0631 15.7236 10.1399 15.6775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.8b04e94d47b67a477481b07328f6c2b8.svg";
export { ForwardRef as ReactComponent };